import { jsx as _jsx } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-components/hooks/useStyles';
import * as React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { BadgeIconStandAlone } from './badgeIconStandAlone';
import { getBadgeIconState } from './utils/state';
const BadgeIconComponent = ({ variant, size, ctv, ...props }, ref) => {
    const variantStyles = useStylesV2({
        styleName: STYLES_NAME.BADGE_ICON,
        customTokens: ctv,
        variantName: variant,
    });
    const sizeStyles = useStylesV2({
        styleName: STYLES_NAME.BADGE_ICON,
        variantName: size,
    });
    const state = getBadgeIconState({ disabled: props.disabled });
    const stateStyles = variantStyles?.[state];
    return _jsx(BadgeIconStandAlone, { ...props, ref: ref, sizeStyles: sizeStyles, styles: stateStyles });
};
export const BadgeIcon = React.forwardRef(BadgeIconComponent);
//# sourceMappingURL=badgeIcon.js.map